import { useMemo } from "react";

import {
  LogoAzureColored,
  LogoBitbucketColored,
  LogoRawGitColored,
  LogoGithub,
  LogoGitlabColored,
} from "components/icons/generated";
import { VcsProvider } from "types/generated";
import { HUMANIZE_PROVIDER } from "constants/vcs_providers";

const vcsProviderConfig = [
  {
    type: VcsProvider.Github,
    name: HUMANIZE_PROVIDER[VcsProvider.Github],
    logo: LogoGithub,
  },
  {
    type: VcsProvider.GithubEnterprise,
    name: HUMANIZE_PROVIDER[VcsProvider.GithubEnterprise],
    logo: LogoGithub,
  },
  {
    type: VcsProvider.Git,
    name: HUMANIZE_PROVIDER[VcsProvider.Git],
    logo: LogoRawGitColored,
  },
  {
    type: VcsProvider.Gitlab,
    name: HUMANIZE_PROVIDER[VcsProvider.Gitlab],
    logo: LogoGitlabColored,
  },
  {
    type: VcsProvider.AzureDevops,
    name: HUMANIZE_PROVIDER[VcsProvider.AzureDevops],
    logo: LogoAzureColored,
  },
  {
    type: VcsProvider.BitbucketCloud,
    name: HUMANIZE_PROVIDER[VcsProvider.BitbucketCloud],
    logo: LogoBitbucketColored,
  },
  {
    type: VcsProvider.BitbucketDatacenter,
    name: HUMANIZE_PROVIDER[VcsProvider.BitbucketDatacenter],
    logo: LogoBitbucketColored,
  },
];

export const useVcsProviderConfig = (supportedProviders?: VcsProvider[]) => {
  const vcsProviderConfigFiltered = useMemo(
    () =>
      supportedProviders
        ? vcsProviderConfig.filter(({ type }) => supportedProviders.includes(type))
        : [],
    [supportedProviders]
  );

  return vcsProviderConfigFiltered;
};
